import React from 'react';
import PropTypes from 'prop-types';
import { SingleSelect } from 'smartsuite-ui';
import { useLabelContext } from '../../shared/hooks/labelContext';
import { systemWidgetType } from '../landingPageConstants';

// eslint-disable-next-line complexity
export default function FilterSelect(props) {
    const { dashboardLabels } = useLabelContext();

    // eslint-disable-next-line complexity
    function isViewSelectValid() {
        return (
            !props.selectedDashboardWidget ||
            props.selectedDashboardWidget.valueField?.type ===
                systemWidgetType ||
            props.savedFilterOptions?.length !== 0
        );
    }

    return (
        <SingleSelect
            errorMessage={dashboardLabels.noSavedFiltersDefined}
            isValid={isViewSelectValid()}
            label={dashboardLabels.filter}
            onChange={props.setSelectedFilter}
            options={props.savedFilterOptions}
            textField="textField"
            valueField="valueField"
            value={props.selectedFilter}
        />
    );
}

FilterSelect.propTypes = {
    savedFilterOptions: PropTypes.instanceOf(Array).isRequired,
    selectedDashboardWidget: PropTypes.oneOfType([
        PropTypes.instanceOf(Object),
        PropTypes.string,
    ]),
    selectedFilter: PropTypes.instanceOf(Object),
    setSelectedFilter: PropTypes.func.isRequired,
};
